<!-- Personal edit -->
<div class="block mb-3 p-3">
  <div class="d-flex justify-content-between align-items-center flex-wrap">
    <h2 class="block-title mb-0">
      {{ "Personal data" | translate }}
    </h2>
    <div class="d-flex justify-content-between flex-wrap">
      <button class="btn aboutus-moreBtn m-2" (click)="showPersonalInfo = true">
        <i class="fas fa-pencil-alt text-primary rtl:ml-1 ltr:mr-1"></i>
        {{ "Modification of personal data" | translate }}
      </button>
      <button
        [disabled]="user?.emailVerified"
        class="btn aboutus-moreBtn m-2"
        (click)="resendActivationLink()"
      >
        <i class="fas fa-paper-plane text-primary rtl:ml-1 ltr:mr-1"></i>
        {{ "Resend activation link" | translate }}
      </button>
    </div>
  </div>

  <div class="form-row">
    <div class="form-group col-12 col-md-8 col-lg-6 col-xl-6">
      <label>{{ "First Name" | translate }}</label>
      <p>
        <strong> {{ user?.firstName }} </strong>
      </p>
    </div>
    <div class="form-group col-12 col-md-8 col-lg-6 col-xl-6">
      <label for="">{{ "Last Name" | translate }}</label>
      <p>
        <strong> {{ user?.lastName }} </strong>
      </p>
    </div>
  </div>
  <div class="form-row">
    <div class="form-group col-12 col-md-8 col-lg-6 col-xl-6">
      <label for="">{{ "Email" | translate }}</label>
      <p>
        <strong> {{ user?.email }} </strong>
      </p>
    </div>
    <div class="form-group col-12 col-md-8 col-lg-6 col-xl-6">
      <label for="">{{ "Mobile number" | translate }}</label>
      <p class="english-digits">
        <strong> {{ user?.mobile }} </strong>
      </p>
    </div>
    <div class="form-group col-12 col-md-8 col-lg-6 col-xl-6">
      <label for="">{{ "KIOSKMode" | translate }}</label>
      <p class="english-digits">
        <strong>{{
          user?.kioskMode
            ? ("ActiveMode" | translate)
            : ("InactiveMode" | translate)
        }}</strong>
      </p>
    </div>
  </div>
</div>
<!-- Personal Save -->
<div class="block mb-3 p-3" *ngIf="showPersonalInfo">
  <div class="d-flex justify-content-between align-items-center flex-wrap">
    <h2 class="block-title mb-0">
      {{ "Modification of personal data" | translate }}
    </h2>
    <div class="flex space-x-1 rtl:space-x-reverse">
      <button
        class="btn btn-primary"
        (click)="save()"
        [disabled]="PersonalInfoForm.invalid"
      >
        <i class="fas fa-save align-middle rtl:ml-1 ltr:mr-1"></i>
        {{ "Save" | translate }}
      </button>
      <button class="btn btn-danger" (click)="showPersonalInfo = false">
        <i class="fas fa-times align-middle rtl:ml-1 ltr:mr-1"></i>
        {{ "cancellation" | translate }}
      </button>
    </div>
  </div>

  <form [formGroup]="PersonalInfoForm">
    <div class="row justify-content-center">
      <div class="col-12 col-xl-10">
        <div class="form-row">
          <div class="form-group col-12 col-md-6">
            <app-evento-input
              [eventoFormControl]="PersonalInfoForm.get('firstName')"
              requiredMessage="{{ 'Required Field' | translate }}"
              label="{{ 'First Name' | translate }}"
              placeholder="{{ 'First Name' | translate }}"
            >
            </app-evento-input>
          </div>
          <div class="form-group col-12 col-md-6">
            <app-evento-input
              [eventoFormControl]="PersonalInfoForm.get('lastName')"
              requiredMessage="{{ 'Required Field' | translate }}"
              label="{{ 'Last Name' | translate }}"
              placeholder="{{ 'Last Name' | translate }}"
            >
            </app-evento-input>
          </div>

          <div class="form-group col-12 col-md-6">
            <app-evento-input
              [eventoFormControl]="PersonalInfoForm.get('email')"
              requiredMessage="{{ 'Required Field' | translate }}"
              patternMessage="{{ 'Valid Email Address' | translate }}"
              label="{{ 'Email' | translate }}"
              placeholder="{{ 'Email' | translate }}"
              [readonly]="true"
            >
            </app-evento-input>
          </div>
          <div class="form-group col-12 col-md-6">
            <app-evento-input
              [eventoFormControl]="PersonalInfoForm.get('mobile')"
              requiredMessage="{{ 'Required Field' | translate }}"
              label="{{ 'Mobile number' | translate }}"
              [readonly]="true"
              class="english-digits"
              placeholder="{{ 'Mobile number' | translate }}"
            >
            </app-evento-input>
          </div>

          <div class="form-group col-12 col-md-6" *ngIf="helpers.isUserAdmin">
            <div class="form-group flex-column">
              <app-evento-select
                [eventoFormControl]="PersonalInfoForm.get('kioskMode')"
                placeholder="{{ 'KIOSKMode' | translate }}"
                label="{{ 'KIOSKMode' | translate }}"
                [multiple]="false"
                [items]="kioskModeOptions"
                [hasStaticValues]="true"
                requiredMessage="{{ 'Required Field' | translate }}"
              >
              </app-evento-select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
<!-- passwords edit -->
<div class="block mb-3 p-3">
  <div class="d-flex justify-content-between flex-wrap align-items-center">
    <h2 class="block-title mb-0">
      {{ "Password management" | translate }}
    </h2>
    <div>
      <button class="btn aboutus-moreBtn" (click)="showEditPassword = true">
        <i class="fas fa-lock text-primary rtl:ml-1 ltr:mr-1"></i>
        {{ "change Password" | translate }}
      </button>
    </div>
  </div>
</div>
<!-- passwords Save -->
<div class="block mb-3 p-3" *ngIf="showEditPassword">
  <div class="d-flex justify-content-between flex-wrap align-items-center">
    <h2 class="block-title mb-0">
      {{ "Password management" | translate }}
    </h2>

    <div class="flex space-x-1 rtl:space-x-reverse">
      <button
        class="btn btn-primary"
        (click)="changePassword()"
        [disabled]="editPasswordForm.invalid"
      >
        <i class="fas fa-save align-middle rtl:ml-1 ltr:mr-1"></i>
        {{ "Save" | translate }}
      </button>
      <button class="btn btn-danger" (click)="showEditPassword = false">
        <i class="fas fa-times align-middle rtl:ml-1 ltr:mr-1"></i>
        {{ "cancellation" | translate }}
      </button>
    </div>
  </div>
  <form [formGroup]="editPasswordForm">
    <div class="form-row">
      <div class="form-group col-12 col-md-4 offset-lg-4">
        <app-evento-input
          [eventoFormControl]="editPasswordForm.get('password')"
          type="password"
          requiredMessage="{{ 'Required Field' | translate }}"
          label="{{ 'new password' | translate }}"
          placeholder="***********"
        ></app-evento-input>
      </div>
      <div class="form-group col-12 col-md-4 offset-lg-4">
        <app-evento-input
          [eventoFormControl]="editPasswordForm.get('confirmPassword')"
          type="password"
          requiredMessage="{{ 'Required Field' | translate }}"
          mustMatchMessage="{{ 'Not Matched' | translate }}"
          label="{{ 'Confirm the new password' | translate }}"
          placeholder="***********"
        ></app-evento-input>
      </div>
    </div>
  </form>
</div>
